export default __webpack_public_path__ + "static/media/foot-right.7a9f9d8e.svg";